import { AuthProps } from "./authProps";
import { DomainConstants } from "domain/infra/data/domainConstants";

class AuthConstants extends DomainConstants {
  public apiAuth: AuthProps;

  constructor() {
    super(1000);

    this.apiAuth = {
      ...this.apiDomain,

      auth: {
        login: `${this.api.baseUrl}/Authentication/Login`,
        alterarPerfil: `${this.api.baseUrl}/Authentication/AlterarPerfil`,
        enviarEmailRecuperacao: `${this.api.baseUrl}/Authentication/EnviarEmailRecuperacao`,
        confirmarSenha: `${this.api.baseUrl}/Authentication/ConfirmarSenha`,
        validarTokenSenha: `${this.api.baseUrl}/Authentication/ValidarTokenSenha`
      },
    } as AuthProps
  }
}

export default new AuthConstants();
